// Instalação da app no telemóvel (PWA). A lógica está aqui, isolada do ecrã, para se poder testar
// sem um browser a sério.

// Quantos dias se respeita um «Agora não» antes de voltar a sugerir a instalação.
export const DISMISS_DAYS = 14;
export const DISMISS_KEY = 'gymag.install.dismissedAt';

/** A app está aberta como app instalada (e não num separador)? Aí não há nada a sugerir. */
export function isStandalone(win = typeof window !== 'undefined' ? window : undefined) {
  if (!win) return false;
  try {
    if (win.navigator && win.navigator.standalone === true) return true;   // iOS antigo
    return !!(win.matchMedia && win.matchMedia('(display-mode: standalone)').matches);
  } catch (e) {
    return false;
  }
}

/** É um iPhone/iPad? O Safari não implementa o beforeinstallprompt — tem de se explicar o caminho. */
export function isIos(win = typeof window !== 'undefined' ? window : undefined) {
  if (!win || !win.navigator) return false;
  const ua = win.navigator.userAgent || '';
  if (/iPad|iPhone|iPod/.test(ua)) return true;
  // O iPad moderno reporta-se como Macintosh; distingue-se pelo toque.
  return /Macintosh/.test(ua) && typeof win.document !== 'undefined' && 'ontouchend' in win.document;
}

/** O utilizador dispensou o aviso recentemente? */
export function isDismissed(storage, now = Date.now()) {
  try {
    if (!storage) return false;
    const at = parseInt(storage.getItem(DISMISS_KEY) || '0', 10);
    return Number.isFinite(at) && at > now;
  } catch (e) {
    return false;
  }
}

/** Grava a decisão de não voltar a insistir durante DISMISS_DAYS. */
export function dismiss(storage, now = Date.now()) {
  try {
    if (storage) storage.setItem(DISMISS_KEY, String(now + DISMISS_DAYS * 24 * 60 * 60 * 1000));
  } catch (e) {
    // sem armazenamento: o aviso volta na próxima visita, sem partir nada
  }
}
